import { useLocation, useNavigate } from "react-router-dom";
import PageContainer from "../../components/page-container";
import Button from "../../components/button";
import PageHeader from "../../components/page-header";

const NoEvents = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const courseName = location.state?.courseName || "your course";

  const handleTryAgain = () => {
    navigate("/upload", { replace: true });
  };

  return (
    <PageContainer>
      <PageHeader
        title="No events detected"
        description={`We didn’t find any events in the syllabus for ${courseName}. Feel free to try again or add them yourself`}
      />
      <Button variant="primary" size="medium" onClick={handleTryAgain}>
        Try again
      </Button>
    </PageContainer>
  );
};

export default NoEvents;
